<div class="main-panel">
  <div class="content">
    <div class="page-inner">
      <div class="page-header">
        <h4 class="page-title">Sales Invoice</h4>
        <ul class="breadcrumbs">
          <li class="nav-home">
            <a href="#">
              <i class="flaticon-home"></i>
            </a>
          </li>
          <li class="separator">
            <i class="flaticon-right-arrow"></i>
          </li>
          <li class="nav-item">
            <a href="#">Stock Outward</a>
          </li>
          <li class="separator">
            <i class="flaticon-right-arrow"></i>
          </li>
          <li class="nav-item">
            <a href="#">Sale Invoice</a>
          </li>
        </ul>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <form
                [formGroup]="salesInvoiceForm"
                class="form-horizontal"
                novalidate
              >
                <!-- <div *ngIf="customerId != 0" class="row">
                  <div class="col-md-12">
                    <label *ngIf="isCustomerOfferEnabled == 'Y'"
                      style="background-color:rgb(147, 225, 147);font-weight: bold;">
                      Customer enabled for offer
                    </label>
                    <label *ngIf="isCustomerOfferEnabled == 'N'"
                      style="background-color:rgb(231, 231, 171);font-weight: bold;">
                      Customer disabled for offer
                    </label>
                  </div>
                </div> -->
                <div class="form-row">
                  <div class="form-col4">
                    <div class="form-field">
                      <div class="position-relative">
                        <ng-select
                          [items]="customers"
                          bindLabel="Code"
                          placeholder="Select Customer Phone/GST"
                          bindValue="ID"
                          formControlName="SearchString"
                          [keyDownFn]="customerKeyDownFn"
                          (change)="getCustomerDetails()"
                          (keyup)="customerKeyDownFn($event.target.value)"
                          required
                        >
                        </ng-select>
                        <button
                          class="btn btn-danger btn-sm position-absolute"
                          style="right: 0; top: 0; height: 100%"
                          data-toggle="modal"
                          data-target="#customerForm"
                          (click)="setCustomerDefaultValues()"
                        >
                          <i class="fas fa-user-plus mr-2"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-col4">
                    <div class="form-field">
                      <input
                        type="text"
                        class="form-control"
                        formControlName="Name"
                        id="name"
                        placeholder=" "
                        readonly
                      />
                      <label class="required">Customer Name</label>
                    </div>
                  </div>
                  <div class="form-col4">
                    <div class="form-field">
                      <input
                        type="text"
                        class="form-control"
                        formControlName="GSTNumber"
                        placeholder=" "
                        readonly
                      />
                      <label class="f-12 font-weight-bold"
                        >Customer GST Number</label
                      >
                    </div>
                  </div>
                  <div class="form-col4">
                    <div class="form-field">
                      <ng-select
                        [items]="salesexecutives"
                        bindLabel="Code"
                        placeholder="Sales Executive "
                        bindValue="ID"
                        formControlName="EmployeeID"
                        required
                        appendTo="body"
                      >
                      </ng-select>
                    </div>
                  </div>
                  <!-- <div class="form-col5">
                    <div class="form-field">
                      <ng-select [items]="costCenterList" bindLabel="CostCenterName" placeholder="Customer Cost Center "
                        bindValue="CostCenterID" formControlName="CustomerCostCenterID"
                        (change)="onCostCenterChange($event)" [addTag]="true" [virtualScroll]="true" appendTo="body">
                      </ng-select>
                      <button class="btn btn-danger btn-sm" style="position: absolute; right: 0; top: 0; height: 100%;"
                        (click)="addCostCenter()" type="button">Add</button>
                    </div>
                  </div> -->

                  <!-- <div class="form-col5">
                    <div class="form-field">
                      <input type="date" formControlName="OutwardDate" id="outwardDate" placeholder=" " readonly
                        required>
                      <label class="required">Invoice Date</label>
                    </div>
                  </div> -->
                </div>
                <div class="form-row">
                  <div class="form-col4">
                    <div class="form-field">
                      <input
                        type="text"
                        formControlName="ReceiverName"
                        id="receiverName"
                        placeholder=" "
                        required
                      />
                      <label class="required">Receiver Name</label>
                    </div>
                  </div>
                  <div class="form-col4">
                    <div class="form-field">
                      <input
                        type="text"
                        formControlName="ReceiverPhone"
                        id="receiverPhone"
                        placeholder=" "
                        required
                      />
                      <label class="required">Receiver Phone Number</label>
                    </div>
                  </div>

                  <div class="form-col4">
                    <div class="form-field">
                      <input
                        type="text"
                        formControlName="WaybillNumber"
                        id="waybillNumber"
                        placeholder=" "
                        required
                      />
                      <label class="required">WayBill Number</label>
                    </div>
                  </div>
                  <div class="form-col4">
                    <div class="form-field">
                      <ng-select
                        [items]="SalesSourceList"
                        bindLabel="Code"
                        placeholder="Sales Source Person"
                        bindValue="ID"
                        formControlName="SourceID"
                        required
                        appendTo="body"
                      >
                      </ng-select>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-col4">
                    <div class="form-field">
                      <ng-select
                        [items]="costCenterList"
                        bindLabel="CostCenterName"
                        placeholder="Customer Cost Center"
                        bindValue="CostCenterID"
                        formControlName="CustomerCostCenterID"
                        (change)="onCostCenterChange($event)"
                        [addTag]="true"
                        [virtualScroll]="true"
                        appendTo="body"
                      >
                      </ng-select>
                      <button
                        class="btn btn-danger btn-sm"
                        style="
                          position: absolute;
                          right: 0;
                          top: 0;
                          height: 100%;
                        "
                        (click)="addCostCenter()"
                        type="button"
                      >
                        Add
                      </button>
                    </div>
                    <div class="form-field">
                      <ng-select
                        [items]="quotationList"
                        bindLabel="QuotationNumber"
                        placeholder="Quotation Number"
                        bindValue="QuotationSlNo"
                        formControlName="QuotationSlNo"
                        (change)="onQuotationChange($event)"
                        [addTag]="true"
                        [virtualScroll]="true"
                        appendTo="body"
                      >
                      </ng-select>
                    </div>
                  </div>
                  <div class="form-col4">
                    <div class="form-field">
                      <ng-select
                        [items]="suppliedLocations"
                        bindLabel="Code"
                        placeholder="Material Supplied At"
                        bindValue="ID"
                        formControlName="MaterialSuppliedAt"
                        required
                        appendTo="body"
                      >
                      </ng-select>
                    </div>
                  </div>
                  <div class="form-col4">
                    <div class="form-field">
                      <input
                        type="text"
                        formControlName="TransporterName"
                        id="transporterName"
                        placeholder=" "
                        required
                      />
                      <label class="required">Transporter Name</label>
                    </div>
                  </div>
                  <div class="form-col4">
                    <div class="form-field">
                      <textarea
                        formControlName="Address"
                        rows="1"
                        id="address"
                        placeholder=" "
                        style="
                          overflow-x: auto;
                          resize: none;
                          white-space: nowrap;
                        "
                      >
                      </textarea>
                      <label class="required">Customer Address</label>
                    </div>
                  </div>
                </div>
                <div class="form-row"></div>
                <div class="row">
                  <div class="col-md-12">
                    <fieldset class="border p-3">
                      <div class="form-row align-items-center py-1">
                        <div
                          class="form-col"
                          style="flex: 0 0 58%; max-width: 58%"
                        >
                          <div class="form-field" *ngIf="itemsFlag">
                            <ng-select
                              #itemSearchSelect
                              [items]="itemsData"
                              bindLabel="Code"
                              placeholder="Search Items"
                              bindValue="ID"
                              formControlName="ItemSearch"
                              [virtualScroll]="true"
                              [enableCellTextSelection]="true"
                              (change)="getItemDetails($event)"
                              [searchFn]="itemSearchFn"
                              appendTo="body"
                              [ngClass]="{
                                'is-invalid':
                                  salesInvoiceForm.get('ItemSearch').touched &&
                                  salesInvoiceForm.get('ItemSearch').invalid
                              }"
                            >
                            </ng-select>
                            <label class="required">Search Items</label>
                          </div>
                        </div>
                        <div
                          class="form-col"
                          style="flex: 0 0 18%; max-width: 18%"
                        >
                          <div
                            *ngIf="batchBalance !== null"
                            class="batch-balance-display"
                          >
                            <small class="text-muted">Avl.Stock:</small>
                            <span class="badge badge-danger">{{
                              batchBalance
                            }}</span>
                          </div>
                          <div
                            *ngIf="batchBalance === null"
                            class="batch-balance-placeholder"
                          >
                            <small class="text-muted"
                              >Select item to view balance</small
                            >
                          </div>
                        </div>
                        <div
                          class="form-col"
                          style="flex: 0 0 20%; max-width: 20%"
                        >
                          <button
                            class="btn btn-danger btn-sm"
                            (click)="refreshItemsData()"
                          >
                            Refresh
                          </button>
                        </div>
                      </div>

                      <div class="form-row">
                        <div
                          class="form-col"
                          style="
                            flex: 0 0 14.2857%;
                            max-width: 14.2857%;
                            padding: 0 4px;
                          "
                        >
                          <div class="form-field">
                            <input
                              type="text"
                              formControlName="ItemClientID"
                              class="form-control form-control-sm text-right"
                              placeholder=" "
                              (keydown.enter)="$event.preventDefault()"
                              readonly
                              (change)="getBarcodeInfo($event)"
                            />
                            <label class="f-12 font-weight-bold required"
                              >Item Code</label
                            >
                          </div>
                        </div>

                        <div
                          class="form-col"
                          style="
                            flex: 0 0 14.2857%;
                            max-width: 14.2857%;
                            padding: 0 4px;
                          "
                        >
                          <div class="form-field">
                            <input
                              type="text"
                              formControlName="ItemName"
                              class="form-control form-control-sm"
                              placeholder=" "
                              readonly
                            />
                            <label class="f-12 font-weight-bold required"
                              >Item Name</label
                            >
                          </div>
                        </div>

                        <div
                          class="form-col"
                          style="
                            flex: 0 0 14.2857%;
                            max-width: 14.2857%;
                            padding: 0 4px;
                          "
                        >
                          <div class="form-field">
                            <input
                              type="number"
                              formControlName="DeliveryQty"
                              id="quantity"
                              min="0"
                              placeholder=""
                              class="form-control form-control-sm"
                              (change)="calculateTotalAmount()"
                              oninput="this.value = Math.abs(this.value)"
                              #qty
                            />
                            <label class="f-12 font-weight-bold required"
                              >Qty.</label
                            >
                          </div>
                        </div>

                        <div
                          class="form-col"
                          style="
                            flex: 0 0 14.2857%;
                            max-width: 14.2857%;
                            padding: 0 4px;
                          "
                        >
                          <div class="form-field">
                            <input
                              type="text"
                              id="unitPrice"
                              formControlName="UnitPrice"
                              placeholder=""
                              class="form-control form-control-sm"
                              (change)="calculateTotalAmount()"
                            />
                            <label class="f-12 font-weight-bold required"
                              >Tag Price</label
                            >
                          </div>
                        </div>

                        <div
                          class="form-col"
                          style="
                            flex: 0 0 14.2857%;
                            max-width: 14.2857%;
                            padding: 0 4px;
                          "
                        >
                          <div class="form-field">
                            <input
                              type="number"
                              formControlName="UnitPriceTax"
                              class="form-control form-control-sm"
                              placeholder=" "
                              readonly
                              min="0"
                              oninput="this.value = Math.abs(this.value)"
                            />
                            <label class="f-12 font-weight-bold"
                              >Unit Price</label
                            >
                          </div>
                        </div>

                        <div
                          class="form-col"
                          style="
                            flex: 0 0 14.2857%;
                            max-width: 14.2857%;
                            padding: 0 4px;
                          "
                        >
                          <div class="form-field">
                            <input
                              type="number"
                              formControlName="Amount"
                              class="form-control form-control-sm"
                              placeholder=" "
                              readonly
                              min="0"
                              oninput="this.value = Math.abs(this.value)"
                            />
                            <label class="f-12 font-weight-bold">Amount</label>
                          </div>
                        </div>

                        <div
                          class="form-col"
                          style="
                            flex: 0 0 14.2857%;
                            max-width: 14.2857%;
                            padding: 0 4px;
                          "
                        >
                          <button
                            class="btn btn-danger btn-sm w-50 mb-2 mr-2"
                            (click)="addToList()"
                          >
                            Add to List
                          </button>
                          <!-- <button class="btn btn-danger btn-sm w-50 mb-2 mr-2" (click)="addToList()" [disabled]="!salesInvoiceForm.value.BatchBalance">Add to List</button> -->
                          <button
                            class="btn btn-danger btn-sm w-30 mb-2"
                            (click)="clearSubFormItemsData()"
                          >
                            Clear
                          </button>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
                <div class="panel panel-primary">
                  <div class="panel-body">
                    <table
                      class="table table-bordered table-hover table-sm wh-table"
                    >
                      <thead style="background-color: #003659; color: white">
                        <tr>
                          <th>Item ID</th>
                          <th width="50%">Item Name</th>

                          <th>HSN</th>
                          <th>Discount</th>
                          <th>IGST %</th>
                          <th>CGST %</th>
                          <th>SGST %</th>
                          <th>Qty</th>
                          <th>Tag Price</th>
                          <th>Unit Price</th>
                          <th>Total</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngIf="!Items.length">
                          <td colspan="12" class="text-center">
                            Please Add Items
                          </td>
                        </tr>
                        <tr
                          *ngFor="let itemData of Items; let i = index"
                          [ngStyle]="{ backgroundColor: itemData.Color }"
                        >
                          <td>{{ itemData.ItemID }}</td>
                          <td>{{ itemData.ItemName }}</td>
                          <td>{{ itemData.HSN }}</td>
                          <td>{{ itemData.DefaultSalesDiscount }}</td>
                          <td>{{ itemData.IGST }}</td>
                          <td>{{ itemData.CGST }}</td>
                          <td>{{ itemData.SGST }}</td>
                          <td>{{ itemData.DeliveryQty }}</td>
                          <td>{{ itemData.UnitPrice }}</td>
                          <td>{{ itemData.UnitPriceTax }}</td>
                          <td>{{ itemData.Amount }}</td>
                          <td style="cursor: pointer; text-align: center">
                            <i
                              (click)="removeItems(i, itemData)"
                              title="Remove"
                              class="fas fa-trash-alt text-danger"
                            ></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div *ngIf="isBusinessCustomer && Items.length > 0" class="row">
                  <div class="col-md-12">
                    <button
                      class="btn btn-danger btn-sm font-weight-bold"
                      data-toggle="modal"
                      data-target="#qrCodeForm"
                    >
                      Add Business Card
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-check form-check-inline ml-4">
                      <input
                        class="form-check-input"
                        type="radio"
                        value="direct-inv"
                        [checked]="showDirectInvoice"
                        (change)="onSaleTypeChange($event.target.value)"
                        name="inlineRadioOptions"
                      />
                      <label class="form-check-label" for="inlineRadio1"
                        >Direct Sale</label
                      >
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        value="finance-inv"
                        [checked]="showFinanceInvoice"
                        (change)="onSaleTypeChange($event.target.value)"
                        name="inlineRadioOptions"
                      />
                      <label class="form-check-label" for="inlineRadio2"
                        >Finance Sale</label
                      >
                    </div>
                  </div>
                </div>
                <div *ngIf="showDownpaymentErr" class="row" style="color: red">
                  <div class="col-md-9" style="color: red">
                    <label style="color: red"
                      >Downpayment should be less than invoice amount</label
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-9">
                    <fieldset
                      *ngIf="showFinanceInvoice"
                      class="border px-2 py-1 mt-2"
                    >
                      <div class="row">
                        <div class="col-md-4 pull-left">
                          <div class="form-field">
                            <ng-select
                              [items]="financersList"
                              bindValue="ID"
                              bindLabel="Value"
                              formControlName="FinanceLedgerID"
                              placeholder="Financer"
                            >
                            </ng-select>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-3 pull-left">
                          <label
                            ><b
                              >Invoice Amount:
                              {{ salesInvoiceForm.value.TotalOutwardAmount }}</b
                            ></label
                          >
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-2 pull-left">
                          <label><b>Downpayment</b></label>
                          <input
                            type="number"
                            formControlName="Downpayment"
                            class="form-control form-control-sm"
                            (change)="getFinanceTotalAmt()"
                          />
                        </div>
                        <div class="col-sm-2 pull-left">
                          <label><b>Processing Fee</b></label>
                          <input
                            type="number"
                            formControlName="ProcessingFee"
                            (change)="getFinanceTotalAmt()"
                            class="form-control form-control-sm"
                          />
                        </div>
                        <div class="col-sm-1 pull-left">
                          <label><b>Intrest</b></label>
                          <input
                            type="number"
                            formControlName="Interest"
                            (change)="getFinanceTotalAmt()"
                            class="form-control form-control-sm"
                            style="width: 65px"
                          />
                        </div>
                        <div class="col-sm-1 pull-left">
                          <label><b>CrdChng</b></label>
                          <input
                            type="number"
                            formControlName="CardCharge"
                            (change)="getFinanceTotalAmt()"
                            class="form-control form-control-sm"
                            style="width: 65px"
                          />
                        </div>
                        <div class="col-sm-2 pull-left">
                          <label><b>Ttl.Recvbl</b></label>
                          <input
                            type="text"
                            formControlName="TotalReceivable"
                            class="form-control form-control-sm"
                            readonly
                          />
                        </div>
                        <div class="col-sm-2 pull-left">
                          <label><b>Payment Type</b></label>
                          <ng-select
                            [items]="paymentTypes"
                            bindLabel="Code"
                            placeholder="Payment Type"
                            bindValue="ID"
                            formControlName="PaymentType"
                          >
                          </ng-select>
                        </div>
                        <div class="col-sm-2 pull-left">
                          <label><b>Ledger</b></label>
                          <ng-select
                            [items]="ledgers"
                            bindLabel="Code"
                            placeholder="Ledger"
                            bindValue="ID"
                            formControlName="AccountID"
                            (change)="selectLedger($event)"
                          >
                          </ng-select>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-2 pull-left">
                          <label><b>Loan Amount</b></label>
                          <input
                            type="number"
                            formControlName="LoanAmount"
                            maxlength="10"
                            (change)="getFinanceDisbursmenAmt()"
                            class="form-control form-control-sm"
                            readonly
                          />
                        </div>
                        <div class="col-md-2 pull-left">
                          <label><b>Subvention Int</b></label>
                          <input
                            type="number"
                            formControlName="SubventionInterest"
                            (change)="getFinanceDisbursmenAmt()"
                            class="form-control form-control-sm"
                          />
                        </div>
                        <div class="col-md-2 pull-left">
                          <label><b>Subvention Amount</b></label>
                          <input
                            type="number"
                            formControlName="SubventionAmount"
                            (change)="getFinanceDisbursmenAmt()"
                            class="form-control form-control-sm"
                            readonly
                          />
                        </div>
                        <div class="col-md-2 pull-left">
                          <label><b>CGST9%</b></label>
                          <input
                            type="text"
                            formControlName="SubvenentionCGST"
                            class="form-control form-control-sm"
                            readonly
                          />
                        </div>
                        <div class="col-md-2 pull-left">
                          <label><b>SGST9%</b></label>
                          <input
                            type="text"
                            formControlName="SubvenentionSGST"
                            class="form-control form-control-sm"
                            readonly
                          />
                        </div>
                        <div class="col-md-2 pull-left">
                          <label><b>Disbursment Amt</b></label>
                          <input
                            type="text"
                            formControlName="DisbursementAmount"
                            class="form-control form-control-sm"
                            readonly
                          />
                        </div>
                      </div>
                    </fieldset>
                    <fieldset
                      *ngIf="showDirectInvoice"
                      class="border px-2 py-1"
                    >
                      <div class="form-row">
                        <div class="form-col3">
                          <div class="form-field">
                            <ng-select
                              [items]="paymentTypes"
                              bindLabel="Code"
                              placeholder="Payment Type"
                              bindValue="ID"
                              formControlName="PaymentType"
                              (change)="onPaymentTypeChange($event.ID)"
                              appendTo="body"
                            >
                            </ng-select>
                          </div>
                          <div
                            *ngIf="showBalanceRedeemPoints"
                            class="text-muted f-12"
                          >
                            <b
                              >Balance Redeem Points:
                              {{ balanceRedeemPoints }}</b
                            >
                          </div>
                          <div class="text-muted f-12">
                            <b
                              >Balance Invoice Amount:
                              {{ BalanceInvoiceAmount }}</b
                            >
                          </div>
                        </div>
                        <div class="form-col3">
                          <div class="form-field">
                            <ng-select
                              [items]="ledgers"
                              bindLabel="Code"
                              placeholder="Ledger "
                              bindValue="ID"
                              formControlName="AccountID"
                              (change)="selectLedger($event)"
                              appendTo="body"
                            >
                            </ng-select>
                          </div>
                          <div
                            *ngIf="showBalanceRedeemPoints"
                            class="text-muted f-12"
                            [ngStyle]="{
                              backgroundColor: redeemableAmountColor
                            }"
                          >
                            <b>Redeemable Amount: {{ redeemableAmount }}</b>
                          </div>
                        </div>
                        <div class="form-col3">
                          <div class="form-field">
                            <input
                              type="text"
                              formControlName="BankName"
                              id="bankName"
                              placeholder=" "
                              min="0"
                            />
                            <label>Bank Name</label>
                          </div>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-col3">
                          <div class="form-field">
                            <input
                              type="text"
                              formControlName="ChequeNumber"
                              id="chequeNo"
                              placeholder=" "
                              min="0"
                            />
                            <label>Cheque No</label>
                          </div>
                        </div>
                        <div class="form-col3">
                          <div class="form-field">
                            <input
                              type="number"
                              formControlName="PaymentAmount"
                              id="amount"
                              placeholder=" "
                              min="0"
                              oninput="this.value = Math.abs(this.value)"
                            />
                            <label>Amount</label>
                          </div>
                        </div>
                        <div class="col-md-2 pull-left">
                          <button
                            class="btn btn-danger font-weight-bold py-1 mt-2"
                            (click)="addPayments()"
                          >
                            Add Payment
                          </button>
                        </div>
                        <div class="form-col"></div>
                      </div>
                    </fieldset>
                    <div class="panel panel-primary mt-2">
                      <div class="panel-body">
                        <table
                          class="table table-bordered table-hover table-sm wh-table"
                        >
                          <thead
                            style="background-color: #003659; color: white"
                          >
                            <tr>
                              <th>Payment Type</th>
                              <th>Ledger</th>
                              <th>Bank Name</th>
                              <th>Cheque No</th>
                              <th>Amount</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngIf="!PaymentReceipts.length">
                              <td colspan="6" class="text-center">
                                Please Add Payments
                              </td>
                            </tr>
                            <tr
                              *ngFor="
                                let itemData of PaymentReceipts;
                                let i = index
                              "
                            >
                              <td>{{ itemData.PaymentType }}</td>
                              <td>{{ itemData.AccountName }}</td>
                              <td>{{ itemData.BankName }}</td>
                              <td>{{ itemData.ChequeNumber }}</td>
                              <td>{{ itemData.PaymentAmount }}</td>
                              <td style="cursor: pointer; text-align: center">
                                <i
                                  (click)="removePayment(i)"
                                  title="Remove"
                                  class="fas fa-trash-alt text-danger"
                                ></i>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-row">
                        <div class="form-col3">
                          <div class="form-field">
                            <input
                              type="text"
                              formControlName="PlaceOfSupply"
                              id="placeOfSupply"
                              placeholder=" "
                              required
                            />
                            <label class="required">Place of Supply</label>
                          </div>
                        </div>
                        <div class="form-col3">
                          <div class="form-field">
                            <input
                              type="text"
                              formControlName="Remarks"
                              id="Remarks"
                              placeholder=" "
                              maxlength="200"
                            />
                            <label>Remarks</label>
                          </div>
                        </div>
                        <div class="form-col3">
                          <div class="form-field">
                            <input
                              type="text"
                              formControlName="ScratchCardCount"
                              id="ScratchCardCount"
                              placeholder=" "
                            />
                            <label>Scratch Cards</label>
                          </div>
                        </div>
                      </div>

                      <div class="form-group row">
                        <div class="col-md-6">
                          <label for="">Reference Number: </label>
                          <label for="" class="font-weight-bold">
                            {{ salesInvoiceObj.OutwardClientID }}</label
                          >
                        </div>
                        <div class="col-md-6">
                          <label for="">Closing Balance: </label>
                          <label for="" class="font-weight-bold">{{
                            salesInvoiceObj.ClosingBalance
                          }}</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="card p-3">
                      <div class="form-row mb-2">
                        <div
                          class="form-col"
                          style="flex: 0 0 50%; max-width: 50%; padding: 0 4px"
                        >
                          <div class="form-field">
                            <input
                              type="number"
                              class="form-control form-control-sm text-right"
                              id="transportationCharges"
                              formControlName="Freight"
                              (change)="calulateSubTotalAndOutwardAmount()"
                              required
                              min="0"
                              oninput="this.value = Math.abs(this.value)"
                            />
                            <label class="f-12 font-weight-bold required"
                              >Freight Charges</label
                            >
                          </div>
                        </div>
                        <div
                          class="form-col"
                          style="flex: 0 0 50%; max-width: 50%; padding: 0 4px"
                        >
                          <div class="form-field">
                            <input
                              type="text"
                              class="form-control form-control-sm text-right"
                              id="subTotal"
                              formControlName="subTotal"
                              readonly
                            />
                            <label class="f-12 font-weight-bold"
                              >Sub Total</label
                            >
                          </div>
                        </div>
                      </div>

                      <div class="form-row mb-2">
                        <div
                          class="form-col"
                          style="flex: 0 0 50%; max-width: 50%; padding: 0 4px"
                        >
                          <div class="form-field">
                            <input
                              type="number"
                              class="form-control form-control-sm text-right"
                              id="Discount"
                              formControlName="Discount"
                              (change)="calaculateOverAllDiscount()"
                              min="0"
                              oninput="this.value = Math.abs(this.value)"
                            />
                            <label class="f-12 font-weight-bold"
                              >Discount</label
                            >
                          </div>
                        </div>
                        <div
                          class="form-col"
                          style="flex: 0 0 50%; max-width: 50%; padding: 0 4px"
                        >
                          <div class="form-field">
                            <input
                              type="number"
                              class="form-control form-control-sm text-right"
                              id="IGST"
                              formControlName="IGST"
                              readonly
                            />
                            <label class="f-12 font-weight-bold">IGST</label>
                          </div>
                        </div>
                      </div>

                      <div class="form-row mb-2">
                        <div
                          class="form-col"
                          style="flex: 0 0 50%; max-width: 50%; padding: 0 4px"
                        >
                          <div class="form-field">
                            <input
                              type="number"
                              class="form-control form-control-sm text-right"
                              id="CGST"
                              formControlName="CGST"
                              readonly
                            />
                            <label class="f-12 font-weight-bold">CGST</label>
                          </div>
                        </div>
                        <div
                          class="form-col"
                          style="flex: 0 0 50%; max-width: 50%; padding: 0 4px"
                        >
                          <div class="form-field">
                            <input
                              type="number"
                              class="form-control form-control-sm text-right"
                              id="SGST"
                              formControlName="SGST"
                              readonly
                            />
                            <label class="f-12 font-weight-bold">SGST</label>
                          </div>
                        </div>
                      </div>

                      <div class="form-row mb-2">
                        <div
                          class="form-col"
                          style="flex: 0 0 50%; max-width: 50%; padding: 0 4px"
                        >
                          <div class="form-field">
                            <input
                              type="number"
                              class="form-control form-control-sm text-right"
                              id="otherCharges"
                              formControlName="OtherCharges"
                              (change)="calulateSubTotalAndOutwardAmount()"
                              required
                              min="0"
                              oninput="this.value = Math.abs(this.value)"
                            />
                            <label class="f-12 font-weight-bold required"
                              >Other Charges</label
                            >
                          </div>
                        </div>
                        <div
                          class="form-col"
                          style="flex: 0 0 50%; max-width: 50%; padding: 0 4px"
                        >
                          <div class="form-field">
                            <input
                              type="text"
                              class="form-control form-control-sm text-right"
                              id="totalOutwardAmount"
                              formControlName="TotalOutwardAmount"
                              readonly
                            />
                            <label class="f-12 font-weight-bold"
                              >Invoice Amount</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="card-action">
              <button
                class="btn btn-danger mr-1"
                (click)="submitSalesInvoice()"
                [disabled]="!salesInvoiceForm.valid"
              >
                Save & Print
              </button>
              <button
                type="button"
                class="btn btn-danger mr-1"
                data-toggle="modal"
                data-target="#prevRecs"
                (click)="getSaleInvoices()"
              >
                Preview
              </button>
              <button class="btn btn-danger" (click)="resetForm()">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="prevRecs">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Pending Actions Form</h4>
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-2">
              <label class="f-15px">Financial Year</label>
            </div>
            <div class="col-md-3">
              <ng-select
                [items]="financialYears"
                bindLabel="Code"
                placeholder="Financial Year"
                bindValue="ID"
                [(ngModel)]="previewFinYear"
                required
              >
              </ng-select>
            </div>
            <div class="col-md-3">
              <button
                type="button"
                class="btn btn-sm btn-danger"
                (click)="getSaleInvoices()"
              >
                Get Invoices
              </button>
            </div>

            <div class="col-md-12">
              <div class="d-flex flex-row-reverse">
                <button
                  type="button"
                  class="btn btn-sm btn-danger mt-2 mb-1"
                  (click)="exportExel()"
                  [disabled]="disableExportBtnGen"
                >
                  <i class="far fa-file-excel mr-2"></i>
                  Export to Excel
                </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <ag-grid-angular
                style="height: 400px"
                class="ag-theme-balham"
                [gridOptions]="gridOptions"
                [columnDefs]="columnDefs"
                [showToolPanel]="showPanel"
                [enableCellTextSelection]="_enableCellTextSelection"
                (rowClicked)="onRowClicked($event)"
                [rowData]="rowData"
                [pagination]="true"
              >
              </ag-grid-angular>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="pull-right"
                >Total Amount : {{ _invoiceAmount }}</label
              >
            </div>
          </div>
          <div class="row mt-3">
            <div *ngFor="let image of ItemImages">
              <img src="{{ image }}" height="100" alt="" class="mb-2" />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            (click)="clearPreviewData()"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="customerForm">
    <div class="modal-dialog">
      <div class="modal-content">
        <form [formGroup]="customerForm" class="form-horizontal" novalidate>
          <div class="modal-body">
            <div class="form-row">
              <div class="form-col">
                <div class="form-field">
                  <ng-select
                    [items]="customerTypeList"
                    bindLabel="name"
                    bindValue="id"
                    placeholder="Customer Type "
                    formControlName="customerType"
                    (change)="onCustomerTypeChange($event)"
                    required
                    appendTo="body"
                  >
                  </ng-select>
                </div>
              </div>
              <div class="form-col">
                <div class="form-field">
                  <input
                    type="text"
                    formControlName="customerPhoneNo"
                    id="customerPhoneNo"
                    placeholder=" "
                    required
                  />
                  <label class="required">Phone Number</label>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-col">
                <div class="form-field">
                  <input
                    type="text"
                    formControlName="customerName"
                    id="customerName"
                    placeholder=" "
                    required
                  />
                  <label class="required">Customer Name</label>
                </div>
              </div>
              <div class="form-col">
                <div class="form-field">
                  <textarea
                    id="customerAddress"
                    formControlName="customerAddress"
                    placeholder=" "
                    required
                  ></textarea>
                  <label class="required">Address</label>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-col">
                <div class="form-field">
                  <ng-select
                    [items]="stateList"
                    bindLabel="StateName"
                    bindValue="StateName"
                    placeholder="State "
                    formControlName="customerState"
                    required
                    appendTo="body"
                  >
                  </ng-select>
                </div>
              </div>
              <div class="form-col">
                <div class="form-field">
                  <ng-select
                    [items]="enableWalletList"
                    bindLabel="name"
                    bindValue="id"
                    placeholder="Enable Offer "
                    formControlName="enableWalletAmount"
                    appendTo="body"
                  >
                  </ng-select>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-col">
                <div class="form-field">
                  <input
                    type="text"
                    formControlName="customerEmail"
                    id="customerEmail"
                    placeholder=" "
                  />
                  <label>EmailID</label>
                </div>
              </div>
              <div class="form-col">
                <div class="form-field">
                  <ng-select
                    [items]="maritalStatusList"
                    bindLabel="name"
                    bindValue="id"
                    placeholder=" Is Married"
                    formControlName="maritalStatus"
                    appendTo="body"
                  >
                  </ng-select>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-col">
                <div class="form-field">
                  <input
                    type="date"
                    formControlName="dob"
                    id="dob"
                    placeholder=" "
                  />
                  <label>DOB</label>
                </div>
              </div>
              <div class="form-col">
                <div class="form-field">
                  <input
                    type="date"
                    formControlName="weddingAnniversary"
                    id="weddingAnniversary"
                    placeholder=" "
                  />
                  <label>Wedding Anniversary</label>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-col">
                <div class="form-field">
                  <input
                    type="text"
                    formControlName="customerGST"
                    id="customerGST"
                    placeholder=" "
                  />
                  <label>GST Number</label>
                </div>
              </div>
              <div class="form-col">
                <div class="form-field">
                  <input
                    type="number"
                    formControlName="creditLimit"
                    id="creditLimit"
                    placeholder=" "
                  />
                  <label>Credit Limit</label>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-col">
                <div class="form-field">
                  <input
                    type="number"
                    formControlName="creditPeriod"
                    id="creditPeriod"
                    placeholder=" "
                  />
                  <label>Credit Period (in Days)</label>
                </div>
              </div>
              <div class="form-col">
                <div class="form-field">
                  <input
                    type="text"
                    formControlName="costCenter"
                    id="costCenter"
                    placeholder=" "
                    required
                  />
                  <label class="required">Cost Centre</label>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-col" style="flex: 0 0 100%; max-width: 100%">
                <div class="form-field">
                  <input
                    type="text"
                    formControlName="otp"
                    id="otp"
                    placeholder=" "
                  />
                  <label>Enter OTP</label>
                  <span *ngIf="showOtpError" class="text-danger f-12"
                    >Please enter OTP</span
                  >
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="modal-footer">
          <button
            class="btn btn-danger btn-sm mr-1"
            (click)="saveCustomer()"
            data-dismiss="modal"
          >
            Save
          </button>
          <button
            class="btn btn-danger btn-sm mr-1"
            (click)="makeCustomerActive()"
          >
            Make Active
          </button>
          <button class="btn btn-danger btn-sm" data-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="customerEnableOfferForm">
    <div class="modal-dialog">
      <div class="modal-content">
        <d
          [formGroup]="customerEnableOfferForm"
          class="form-horizontal"
          novalidate
        >
          <div class="modal-body">
            <div class="row">
              <div class="col-10">
                <div class="row">
                  <div class="col-md-4">
                    <label class="f-12 font-weight-bold">Customer Name</label>
                  </div>
                  <div class="col-md-6">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      formControlName="customerName"
                      name="customerName"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-10">
                <div class="row">
                  <div class="col-md-4">
                    <label class="f-12 font-weight-bold">Phone Number</label>
                  </div>
                  <div class="col-md-6">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      formControlName="customerPhoneNo"
                      name="customerPhoneNo"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-10">
                <div class="row">
                  <div class="col-md-4">
                    <label class="f-12 font-weight-bold">EmailID</label>
                  </div>
                  <div class="col-md-6">
                    <input
                      class="form-control form-control-sm"
                      formControlName="customerEmail"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-10">
                <div class="row">
                  <div class="col-md-4">
                    <label class="f-12 font-weight-bold">Is Married</label>
                  </div>
                  <div class="col-md-6">
                    <ng-select
                      formControlName="maritalStatus"
                      [items]="maritalStatusList"
                      bindValue="id"
                      bindLabel="name"
                      placeholder="Select"
                    >
                    </ng-select>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-10">
                <div class="row">
                  <div class="col-md-4">
                    <label class="f-12 font-weight-bold">DOB</label>
                  </div>
                  <div class="col-md-6">
                    <input
                      type="date"
                      formControlName="dob"
                      class="form-control form-control-sm"
                      id="dob"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="row"></div>
            <div class="col-10">
              <div class="row">
                <div class="col-md-4">
                  <label class="f-12 font-weight-bold"
                    >Wedding Anniversary</label
                  >
                </div>
                <div class="col-md-6">
                  <input
                    type="date"
                    formControlName="weddingAnniversary"
                    class="form-control form-control-sm"
                  />
                </div>
              </div>
              <div class="modal-footer">
                <button
                  class="btn btn-danger font-weight-bold btn-sm mr-1"
                  (click)="enableOrDisableCustomerOffer('Y')"
                >
                  Enable Offer
                </button>
                <button
                  class="btn btn-secondary font-weight-bold btn-sm mr-1"
                  (click)="enableOrDisableCustomerOffer('N')"
                >
                  Disable Offer
                </button>
                <button
                  class="btn btn-danger btn-sm font-weight-bold"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>

              <div class="modal" [ngStyle]="{ display: display }">
                <div class="modal-dialog modal-lg">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">Advance Items</h5>
                      <button
                        type="button"
                        class="close"
                        (click)="onCloseHandled()"
                        data-dismiss="modal"
                      >
                        &times;
                      </button>
                    </div>
                    <div class="modal-body">
                      <ag-grid-angular
                        style="height: 200px"
                        class="ag-theme-balham"
                        [gridOptions]="gridOptions"
                        [columnDefs]="columnDefsAdvanceItems"
                        [showToolPanel]="showPanel"
                        [rowData]="advanceItemsList"
                      >
                      </ag-grid-angular>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-danger"
                        (click)="onCloseHandled()"
                        data-dismiss="modal"
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal" id="qrCodeForm">
                <div class="modal-dialog modal-md">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">Scan QRCode</h5>
                      <button
                        type="button"
                        class="close"
                        (click)="onCloseHandled()"
                        data-dismiss="modal"
                      >
                        &times;
                      </button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-12">
                          <div class="row">
                            <div class="col-md-4"></div>
                            <label class="f-12 font-weight-bold"
                              >Sacn QRCode</label
                            >
                          </div>
                          <div class="col-md-8">
                            <input
                              type="password"
                              class="form-control form-control-sm"
                              [(ngModel)]="qrCode"
                              name="creditLimit"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-danger btn-sm"
                      (click)="applyBusinessItmesPrice()"
                      data-dismiss="modal"
                    >
                      Apply Business Price
                    </button>
                    <button
                      type="button"
                      class="btn btn-danger btn-sm"
                      (click)="onCloseHandled()"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <app-footer></app-footer>
          </div>
        </d>
      </div>
    </div>
  </div>
</div>
